import { Button, Stack } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { LibraryBreadcrumbs } from "./library-breadcrumbs"

export function EmbeddedLibraryHeader() {
    const { breadcrumbs, categoryId, selectedTaskId, libraryActions } = useBoundContext()

    return (
        <Stack direction="column" alignItems="flex-start" spacing={2}>
            <LibraryBreadcrumbs breadcrumbs={breadcrumbs} />
            <Button
                size="small"
                variant="contained"
                color="primary"
                startIcon={<Iconify icon="ic:round-keyboard-backspace" />}
                onClick={libraryActions.onNavigateBack}
                disabled={!selectedTaskId && categoryId === "components"}
                data-cy="library-back-button"
            >
                Back
            </Button>
        </Stack>
    )
}
